const ACTIONS={
        JOIN:'join',
        JOINED:'joined',
        SENDMESSAGE:"send-message",
        RECEIVEMESSAGE:"receive-message",
        DISCONNECTED:'disconnected',
        CODE_CHANGE:'code-change',
        SYNC_CODE:'sync-code',
        SYNC_MESSAGE:'sync-message',
        LEAVE:'leave'
};
module.exports=ACTIONS;